import AllUser from "./AllUser";

const AllClinic = () => (
  <AllUser
    pageTitle="All Clinics"
    defaultType="1"
    defaultEmpType="2"
    hideTypeFilter
    hideEmployeeTypeFilter
  />
);

export default AllClinic;
